import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import {
  DoconModalContent,
  DoconModal,
} from '@docon/docon-ui-library';
import EmrSMS from 'components/EmrSMS';

const Modal = styled(DoconModal)`
  --contentTop: 0;
  height: 100%;
  width: 100%;
  border-radius: 0;

  ${DoconModalContent} {
    text-align: center;
    max-height: initial;
  }

  ${EmrSMS} {
    padding: 12px 0 0;
    min-height: 100%;
  }
`;

function EmrSMSModal() {
  const [cookies, setCookie] = useCookies(['hideEmrSMS']);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (cookies.hideEmrSMS)
      setIsOpen(false);
    else
      setCookie('hideEmrSMS', true, {
        path: '/',
        maxAge: 86400, // 24*60*60 1 day
      });
  }, []);

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <Modal
      hideFooter
      hideCrossIcon
      isOpen={isOpen}
    >
      <EmrSMS
        onContinueToWeb={handleClose}
      />
    </Modal>
  );
}

export default EmrSMSModal;